import { __extends } from "tslib";
// DS: C15
import React from 'react';
import classnames from 'classnames';
import numeral from 'numeral';
import { withTranslation } from 'react-i18next';
import onClickOutside from 'react-onclickoutside';
import { BiData } from '@wix/da-bi/pkg/events';
import { URLS, Url } from '@wix/da-url';
import StandardMenu from '../../../Dropdown/MenuPreset/StandardMenu';
import UserAvatar from '../../../User/Avatar';
import UserAvatarPlaceholder from '../../../User/AvatarPlaceholder';
import UserLink from '../../../User/Link';
import MatureToggle from '../../../MatureToggle';
import CoreMenuItem from '../../_partials/CoreMenuItem';
import LogoutItem from '../../_partials/LogoutItem';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import Flex from '@wix/da-ds/pkg/Flex';
import VerificationReminder from '../../_partials/VerificationReminder';
import ThemeSwitchGreen from '@wix/da-ds/pkg/Icons/ThemeSwitchGreen';
import ThemeSwitchLight from '@wix/da-ds/pkg/Icons/ThemeSwitchLight';
import ThemeSwitchDark from '@wix/da-ds/pkg/Icons/ThemeSwitchDark';
import Button from '../../../Button';
import IconButton from '../../../Button/IconButton';
import SaleBanner from '../../../SaleBanner';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import Eye from '@wix/da-ds/pkg/Icons/Eye';
import Trashcan from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import { ThemeOverride, ThemeOptions, ThemeSkin, } from '@wix/da-react-context/pkg/ThemeContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import LoadablePortfolioReduxModule from '../../../WixPortfolio/LoadablePortfolioReduxModule';
import UserSymbol from '../UserSymbol';
import { getUserType } from '../../../User/helpers';
import SiteHeaderStyles from '../SiteHeaderDesktop.scss';
import s from './UserDropdownMenu.scss';
var UserDropdownMenu = /** @class */ (function (_super) {
    __extends(UserDropdownMenu, _super);
    function UserDropdownMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            touchIsOpen: false,
        };
        _this.logoutItemRef = React.createRef();
        _this.getBuyCore = function () {
            var _a = _this.props, hasCoreMembership = _a.hasCoreMembership, coreLevel = _a.coreLevel;
            var linkUrl = hasCoreMembership
                ? URLS.SETTINGS_BILLING
                : URLS.CORE_MEMBERSHIP;
            return {
                label: (React.createElement(CoreMenuItem, { className: s['two-side-label'], hasCoreMembership: hasCoreMembership, coreLevel: coreLevel })),
                link: linkUrl,
                biData: BiData({
                    evid: 702,
                    link_url: linkUrl,
                    menu_item: hasCoreMembership ? 'my_core' : 'core_membership',
                    menu_name: 'profile',
                }),
            };
        };
        _this.getSubscriptions = function () {
            var _a = _this.props, currentUser = _a.currentUser, hasSubscriptions = _a.hasSubscriptions, t = _a.t;
            var loggedInUser = currentUser;
            if (!loggedInUser || !hasSubscriptions) {
                return null;
            }
            var linkUrl = Url.userSubscriptionsLink({
                username: loggedInUser.username,
            });
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", null, t('siteHeader.userMenu.mySubscriptions')),
                    React.createElement("span", null,
                        React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
                            React.createElement(TierBadge, { size: 24 }))))),
                link: linkUrl,
                biData: BiData({
                    evid: 702,
                    link_url: linkUrl,
                    menu_item: 'my_subscriptions',
                    menu_name: 'profile',
                }),
            };
        };
        _this.getSaleBanner = function () {
            var currentPromo = _this.props.currentPromo;
            return (currentPromo && {
                className: s['non-clickable'],
                label: (React.createElement(SaleBanner, { className: s['sale-banner'], isNarrow: true, endDate: currentPromo.endDate, discountValuePercent: currentPromo.discountValuePercent, referralType: ReferralType.PROMOTION_BANNER_USERMENU })),
            });
        };
        _this.getMatureToggleItem = function () {
            var _a = _this.props, t = _a.t, _b = _a.matureContent, matureContent = _b === void 0 ? false : _b, toggleMature = _a.toggleMature;
            return {
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", { id: "mature-toggle-label", onClick: function () { return toggleMature(matureContent); } }, t('siteHeader.userMenu.matureContent')),
                    React.createElement(MatureToggle, { size: "small", value: matureContent, onChange: toggleMature, "aria-labelledby": "mature-toggle-label" }))),
                biData: BiData({
                    evid: 702,
                    menu_item: 'toggle_mature',
                    menu_name: 'profile',
                    toggle_value: !matureContent ? 'mature_on' : 'mature_off',
                }),
            };
        };
        _this.getWixPortfolio = function () {
            var _a = _this.props, t = _a.t, hasWixPortfolio = _a.hasWixPortfolio, pushWixPortfolioModal = _a.pushWixPortfolioModal, isLegacyHeader = _a.isLegacyHeader, deletePortfolio = _a.deletePortfolio, isPortfolioReduxReady = _a.isPortfolioReduxReady;
            var createPortfolio = pushWixPortfolioModal;
            if (isLegacyHeader) {
                var url_1 = "".concat(Url.browseHomeLink(), "?submit_modal=portfolio");
                createPortfolio = function () {
                    window.location.assign(url_1);
                };
            }
            return {
                label: (React.createElement("div", { className: classnames(s['two-side-label'], s['portfolio-label']) },
                    React.createElement(PlainButtonOrLink, { className: s['portfolio-text'], onClick: hasWixPortfolio ? undefined : createPortfolio, href: hasWixPortfolio ? '/wixsite/edit' : undefined, target: "_blank", biData: {
                            evid: hasWixPortfolio
                                ? BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK
                                : BiEventType.WIX_PORTFOLIO_CREATE_CLICK,
                            sectionname: 'usermenu',
                            button_type: 'portfolio',
                        }, disabled: !hasWixPortfolio && !isPortfolioReduxReady },
                        t('siteHeader.userMenu.wixPortfolio.portfolio'),
                        React.createElement("span", { className: s['portfolio-beta'] }, "beta")),
                    React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT }, hasWixPortfolio ? (React.createElement(React.Fragment, null,
                        React.createElement(TextTooltipOnHover, { className: s['portfolio-button'], tooltipText: t('comment.action.edit'), oneLine: true },
                            React.createElement(BiLink, { href: "/wixsite/edit", target: "_blank", biData: {
                                    evid: BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK,
                                    sectionname: 'username',
                                    button_type: 'edit',
                                } },
                                React.createElement(EditIcon, { disableDefaultColors: true }))),
                        React.createElement(TextTooltipOnHover, { className: s['portfolio-button'], tooltipText: t('comment.action.view'), oneLine: true },
                            React.createElement(BiLink, { href: "/wixsite/view", target: "_blank", biData: {
                                    evid: BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK,
                                    sectionname: 'usermenu',
                                    button_type: 'preview',
                                } },
                                React.createElement(Eye, { disableDefaultColors: true }))),
                        React.createElement(IconButton, { className: classnames(s['portfolio-button'], s['portfolio-delete']), onClick: deletePortfolio, tooltipText: t('comment.action.delete'), biData: {
                                evid: BiEventType.WIX_PORTFOLIO_PREVIEW_EDIT_CLICK,
                                sectionname: 'username',
                                button_type: 'delete',
                            }, disabled: !isPortfolioReduxReady },
                            React.createElement(Trashcan, { disableDefaultColors: true })))) : (React.createElement(Button, { view: "b3", onClick: createPortfolio, className: s['portfolio-create-button'], biData: {
                            evid: BiEventType.WIX_PORTFOLIO_CREATE_CLICK,
                            sectionname: 'usermenu',
                        }, disabled: !isPortfolioReduxReady }, t('siteHeader.userMenu.wixPortfolio.create')))))),
            };
        };
        _this.getThemeSwitcherIfApplicable = function () {
            var _a = _this.props, t = _a.t, disableThemeSwitcher = _a.disableThemeSwitcher, theme = _a.theme, themeSkin = _a.themeSkin, setThemeSkin = _a.setThemeSkin, setTheme = _a.setTheme;
            if (disableThemeSwitcher) {
                return null;
            }
            return {
                className: s['non-clickable'],
                label: (React.createElement("div", { className: s['two-side-label'] },
                    React.createElement("span", { className: s['no-hover'] }, t('siteHeader.userMenu.mode')),
                    React.createElement("span", { className: s['theme-toggles'] },
                        React.createElement(BiSpan, { title: t('siteHeader.userMenu.themeDark'), onClick: function () { return setTheme(ThemeOptions.DARK); }, className: classnames(s['theme-toggle-item'], theme === ThemeOptions.DARK && !themeSkin && s['active']), biData: BiData({
                                evid: 702,
                                menu_item: 'toggle_theme',
                                menu_name: 'profile',
                                toggle_value: 'dark',
                            }) },
                            React.createElement(ThemeSwitchDark, { size: IconSize.LARGE })),
                        React.createElement(BiSpan, { title: t('siteHeader.userMenu.themeLight'), onClick: function () { return setTheme(ThemeOptions.LIGHT); }, className: classnames(s['theme-toggle-item'], theme === ThemeOptions.LIGHT && !themeSkin && s['active']), biData: BiData({
                                evid: 702,
                                menu_item: 'toggle_theme',
                                menu_name: 'profile',
                                toggle_value: 'light',
                            }) },
                            React.createElement(ThemeSwitchLight, { size: IconSize.LARGE })),
                        React.createElement(BiSpan, { title: t('siteHeader.userMenu.themeGreen'), onClick: function () { return setThemeSkin(ThemeSkin.GREEN); }, className: classnames(s['theme-toggle-item'], themeSkin === ThemeSkin.GREEN && s['active']), biData: BiData({
                                evid: 702,
                                menu_item: 'toggle_theme',
                                menu_name: 'profile',
                                toggle_value: 'green',
                            }) },
                            React.createElement(ThemeSwitchGreen, { size: IconSize.LARGE }))))),
            };
        };
        _this.handleLogout = function () {
            _this.props.onUserLogoutButtonClicked();
            // Avoid a race condition and let sagas do their thing before submitting the form
            setTimeout(function () {
                _this.logoutItemRef &&
                    _this.logoutItemRef.current &&
                    _this.logoutItemRef.current.submit();
            }, 100);
        };
        _this.handleTouch = function (e) {
            e.preventDefault();
            _this.setState({ touchIsOpen: true });
        };
        _this.handleClickOutside = function () {
            if (!_this.state.touchIsOpen) {
                return;
            }
            _this.setState({ touchIsOpen: false });
        };
        _this.handleClickUserMenuOpen = function () {
            _this.setState({
                touchIsOpen: !_this.state.touchIsOpen,
            });
        };
        return _this;
    }
    UserDropdownMenu.prototype.renderLoggedInMenu = function () {
        var _a = this.props, t = _a.t, className = _a.className, currentUser = _a.currentUser, pointsCount = _a.pointsCount, fragmentsBalance = _a.fragmentsBalance, csrfToken = _a.csrfToken, verificationEmail = _a.verificationEmail, canEnableMatureContent = _a.canEnableMatureContent;
        var loggedInUser = currentUser;
        return (React.createElement(StandardMenu, { lightText: true, id: "site-header-user-menu", role: "dialog", className: classnames(className, s['user-menu'], SiteHeaderStyles['icon-submenu']), itemClassName: s['user-menu-item'], groupClassName: s['user-menu-group'], items: [
                {
                    items: [
                        {
                            label: (React.createElement(Flex, { alignItems: "baseline", justifyContent: "space-between", className: s['user-profile-line'] },
                                React.createElement(UserLink, { className: s['user-link'], symbolClassName: s['user-link-symbol'], user: loggedInUser, withTooltip: false, biData: {
                                        sectionname: 'menu',
                                    } }))),
                        },
                        this.getBuyCore(),
                        this.getSubscriptions(),
                        this.getSaleBanner(),
                    ],
                },
                !!verificationEmail && {
                    items: [
                        {
                            label: React.createElement(VerificationReminder, { email: verificationEmail }),
                            className: s['verification-item'],
                        },
                    ],
                    className: s['verification-group'],
                },
                !verificationEmail && {
                    items: [
                        {
                            label: t('siteHeader.userMenu.myStash'),
                            link: Url.buildFromPath(URLS.STASH),
                            biData: BiData({
                                evid: 702,
                                link_url: Url.buildFromPath(URLS.STASH),
                                menu_item: 'stash',
                                menu_name: 'profile',
                            }),
                        },
                        this.getWixPortfolio(),
                    ],
                },
                !verificationEmail && {
                    items: [
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement("span", null, t('siteHeader.userMenu.pointsBalance')),
                                pointsCount && (React.createElement("span", null, numeral(pointsCount).format('0,0'))))),
                            link: URLS.POINTS,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.POINTS,
                                menu_item: 'points',
                                menu_name: 'profile',
                            }),
                        },
                        {
                            label: (React.createElement("div", { className: s['two-side-label'] },
                                React.createElement("span", null, t('siteHeader.userMenu.fragmentsBalance')),
                                React.createElement("span", null, numeral(fragmentsBalance).format('0,0')))),
                            link: 'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments',
                            target: '_blank',
                            className: s['fragments-link'],
                            biData: BiData({
                                evid: 702,
                                link_url: 'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments',
                                menu_item: 'fragments',
                                menu_name: 'profile',
                            }),
                        },
                        {
                            label: t('siteHeader.userMenu.myEarnings'),
                            link: URLS.EARNINGS,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.EARNINGS,
                                menu_item: 'earnings',
                                menu_name: 'profile',
                            }),
                        },
                        {
                            label: t('siteHeader.userMenu.myOrderHistory'),
                            link: URLS.ORDERS,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.ORDERS,
                                menu_item: 'order_history',
                                menu_name: 'profile',
                            }),
                        },
                        {
                            label: t('siteHeaderMobile.userMenu.customerDashboard'),
                            link: URLS.CUSTOMER_DASHBOARD,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.CUSTOMER_DASHBOARD,
                                menu_item: 'customer_dashboard',
                                menu_name: 'profile',
                            }),
                        },
                    ],
                },
                {
                    items: [
                        !!verificationEmail && {
                            label: t('siteHeader.userMenu.myOrderHistory'),
                            link: URLS.ORDERS,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.ORDERS,
                                menu_item: 'order_history',
                                menu_name: 'profile',
                            }),
                        },
                        this.getThemeSwitcherIfApplicable(),
                        {
                            label: t('siteHeader.userMenu.settings'),
                            link: URLS.SETTINGS,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.SETTINGS,
                                menu_item: 'settings',
                                menu_name: 'profile',
                            }),
                        },
                        canEnableMatureContent && this.getMatureToggleItem(),
                    ],
                    className: verificationEmail && s['post-verification-group'],
                },
                {
                    items: [
                        {
                            label: t('siteHeader.userMenu.helpAndFAQ'),
                            link: URLS.HELP,
                            target: '_blank',
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.HELP,
                                menu_item: 'help_and_faq',
                                menu_name: 'profile',
                            }),
                        },
                        {
                            label: (React.createElement(LogoutItem, { formRef: this.logoutItemRef, token: csrfToken, label: React.createElement(BiSpan, { biData: BiData({
                                        evid: 702,
                                        link_url: URLS.LOGOUT,
                                        menu_item: 'logout',
                                        menu_name: 'profile',
                                    }) }, t('siteHeader.userMenu.logOut')) })),
                            onClick: this.handleLogout,
                        },
                    ],
                },
            ] }));
    };
    UserDropdownMenu.prototype.renderLoggedOutMenu = function () {
        var _a = this.props, t = _a.t, className = _a.className;
        return (React.createElement(StandardMenu, { lightText: true, id: "site-header-user-menu", role: "dialog", className: classnames(className, s['user-menu'], SiteHeaderStyles['icon-submenu']), items: [
                {
                    items: [
                        this.getBuyCore(),
                        this.getSaleBanner(),
                        this.getThemeSwitcherIfApplicable(),
                        this.getMatureToggleItem(),
                    ],
                },
                {
                    items: [
                        {
                            label: t('siteHeader.userMenu.helpAndFAQ'),
                            link: URLS.HELP,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.HELP,
                                menu_item: 'help_and_faq',
                                menu_name: 'profile',
                            }),
                        },
                        {
                            label: t('siteHeader.userMenu.termsOfService'),
                            link: URLS.TOS,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.TOS,
                                menu_item: 'tos',
                                menu_name: 'profile',
                            }),
                        },
                        {
                            label: t('siteHeader.userMenu.privacyPolicy'),
                            link: URLS.PRIVACY,
                            biData: BiData({
                                evid: 702,
                                link_url: URLS.PRIVACY,
                                menu_item: 'privacy_policy',
                                menu_name: 'profile',
                            }),
                        },
                    ],
                },
            ] }));
    };
    UserDropdownMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, currentUser = _a.currentUser, verificationEmail = _a.verificationEmail, isLoggedIn = _a.isLoggedIn, isOpen = _a.isOpen, innerRef = _a.innerRef;
        var touchIsOpen = this.state.touchIsOpen;
        var avatarClassName = classnames(SiteHeaderStyles['icon-button'], s['avatar']);
        return (React.createElement("div", { className: classnames(s['user-dropdown'], SiteHeaderStyles['icon-button-has-submenu'], (isOpen || touchIsOpen) && SiteHeaderStyles['active'], verificationEmail && SiteHeaderStyles['pulsing-animation']), ref: innerRef },
            React.createElement(LoadablePortfolioReduxModule, null),
            React.createElement(Button, { view: "b3", className: s['user-menu-button'], "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": "site-header-user-menu", onClick: this.handleClickUserMenuOpen }, t('siteHeader.userMenu.open')),
            isLoggedIn && (React.createElement(React.Fragment, null,
                React.createElement(UserAvatar, { user: currentUser, size: 30, className: avatarClassName, withLink: true, onTouchEnd: function (e) { return _this.handleTouch(e); }, withTooltip: false, biData: { sectionname: 'header' } }),
                !verificationEmail && (React.createElement(UserSymbol, { userType: getUserType(currentUser) })),
                this.renderLoggedInMenu())),
            !isLoggedIn && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: avatarClassName },
                    React.createElement(UserAvatarPlaceholder, { width: 30, height: 30 })),
                this.renderLoggedOutMenu()))));
    };
    return UserDropdownMenu;
}(React.Component));
export { UserDropdownMenu };
export default withTranslation()(onClickOutside(UserDropdownMenu));
//# sourceMappingURL=UserDropdownMenu.js.map